import React, { Component } from "react";
import "../style/productDetail.scss";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import { getProductDetailById } from "../apis/GetProduct";
import Truck from "../icon/Truck";
import Time from "../icon/Time";
import Star from "../icon/Star";
import Number from "./common/Number";
import SnowFlower from "../icon/SnowFlower";
import Approve from "../icon/Approve";
import desc from "../image/desc.webp";
import desc1 from "../image/desc1.webp";
import { Rate } from "antd";
import { productList, getCategoryList } from "../apis/GetProduct";
import Calendar from "../icon/Calendar";
import large from "../image/large.png";
import detail from "../image/detail.png";

class ProductDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: {},
      isActive: 0,
    };
    this.clickChangeImage = this.clickChangeImage.bind(this);
    this.clickAddToCart = this.clickAddToCart.bind(this);
    this.selectSku = this.selectSku.bind(this);
    this.NumberCallBack = this.NumberCallBack.bind(this);
    this.routeProductDetail = this.routeProductDetail.bind(this);
  }

  headerRef = React.createRef();
  numberRef = React.createRef();

  componentDidMount() {
    window.scrollTo(0, 0);
    let { location } = this.props;
    let id = location.pathname.replace("/ProductDetail/", "");
    let product = getProductDetailById(parseInt(id));
    console.log(product);

    this.setState({ product });
  }

  clickChangeImage(index) {
    this.setState({ isActive: index });
  }

  selectSku(index) {
    this.setState((prevState) => ({
      product: {
        ...prevState.product,
        sku: prevState.product.sku.map((item) => ({
          ...item,
          select: item.select.map((skuItem, skuIndex) => ({
            ...skuItem,
            checked: skuIndex === index,
          })),
        })),
      },
    }));
  }

  clickAddToCart(product) {
    let { history } = this.props;
    let isProductInCart = false;
    let quantity = 0;

    if (this.headerRef) {
      let cartList = this.headerRef.current.state.cartList;

      if (cartList.length <= 0) {
        cartList.push(product);
      } else {
        for (let i = 0; i < cartList.length; i++) {
          if (cartList[i].id === product.id) {
            cartList[i].quantity += product.quantity;
            cartList[i].total = (
              cartList[i].quantity * parseFloat(product.price)
            ).toFixed(2);
            isProductInCart = true;
            break;
          }
        }

        if (!isProductInCart) {
          cartList.push(product);
        }
      }

      cartList.forEach((item) => {
        quantity += item.quantity;
      });

      this.headerRef.current.setState({ cartList, quantity });
      localStorage.setItem("cart", JSON.stringify(cartList));
      localStorage.setItem("quantity", JSON.stringify(quantity));
      history.push("/Cart");
    }
  }

  NumberCallBack(num) {
    let { product } = this.state;
    product.quantity = num;
    this.setState({ product });
  }

  routeProductDetail(id) {
    let { history } = this.props;
    history.push(`/ProductDetail/${id}`);
  }

  render() {
    let { product, isActive } = this.state;

    let category3 = getCategoryList("Recently viewed");

    return (
      <React.Fragment>
        <HeaderBar {...this.props} ref={this.headerRef} />
        <div className="productDetail-page">
          <div className="productDetail">
            <div className="row1">
              <div className="left-box">
                <div className="little-img">
                  {product?.image?.map((item, index) => {
                    return (
                      <div
                        className={`item ${isActive === index ? "active" : ""}`}
                        key={index}
                        onClick={() => {
                          this.clickChangeImage(index);
                        }}
                      >
                        <img src={item} alt="" />
                      </div>
                    );
                  })}
                </div>
                <div className="big-img">
                  <img src={product?.image?.[isActive]} alt="" />
                </div>
              </div>
              <div className="right-box">
                <div className="title">{product?.title}</div>
                <div className="star">
                  <Rate
                    disabled
                    defaultValue={5}
                    style={{ fontSize: 14, color: "rgb(221, 109, 10)" }}
                  />
                </div>
                <div className="price">￡{product?.price}</div>

                {product?.sku && (
                  <div className="sku">
                    {product?.sku?.map((item, index) => {
                      return (
                        <div className="li" key={index}>
                          <div className="title">{item.title}</div>
                          <div className="select-li">
                            {item.select.map((item, skuindex) => {
                              return (
                                <li
                                  key={skuindex}
                                  className={item.checked ? "active" : ""}
                                  onClick={() => this.selectSku(skuindex)}
                                >
                                  {item.value}
                                </li>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="buy-row">
                  <p>Quantity </p>
                  <Number
                    num={product?.quantity}
                    receiveNum={(num) => this.NumberCallBack(num)}
                    ref={this.numberRef}
                  />
                </div>
                <div
                  className="addToCart"
                  onClick={() => this.clickAddToCart(product)}
                >
                  Add To Cart
                </div>
                <div className="delivery">
                  <div className="title">Shipping & delivery</div>
                  <p>
                    This item will be posted to you by Fanciful Furnishings of
                    Shrewsbury within 5 days of receiving payment.
                  </p>
                  <p>
                    <img src={detail} alt="" />
                  </p>
                  <div className="title">Returns & shipping policy</div>
                  <p>
                    You have 14 days, from receipt, to notify the seller if you
                    wish to cancel your order or exchange an item.
                  </p>
                  <p>
                    Unless faulty, the following types of items are
                    non-refundable: items that are personalised, bespoke or
                    made-to-order to your specific requirements; items which
                    deteriorate quickly (e.g. food), personal items sold with a
                    hygiene seal (cosmetics, underwear) in instances where the
                    seal is broken; digital items.
                  </p>
                  <p>
                    Please note that if your order is being posted outside
                    mainland UK, you (or the recipient) may have to pay customs
                    or VAT charges and a handling fee. The seller is not
                    responsible for any charges or fees that may incur.
                  </p>
                </div>
              </div>
            </div>
            <div className="row2">
              {product?.detail?.map((item, index) => {
                return (
                  <div className="col" key={index}>
                    {item.map((li, liIndex) => {
                      return <li key={liIndex}>{li}</li>;
                    })}
                  </div>
                );
              })}
            </div>
            <div className="sec4">
              <div className="title">{category3?.category}</div>
              <div className="row">
                {category3?.list?.map((item, index) => {
                  return (
                    <div
                      className="col"
                      key={index}
                      onClick={() => this.routeProductDetail(item.id)}
                    >
                      <div className="img-box">
                        {item.isHover ? (
                          <img src={item.image[1]} lt="" />
                        ) : (
                          <img src={item.image[0]} lt="" />
                        )}
                      </div>
                      <div className="txt">
                        <div className="title">{item.title}</div>
                        <div className="star">
                          <Rate
                            disabled
                            defaultValue={5}
                            style={{ fontSize: 14, color: "rgb(221, 109, 10)" }}
                          />
                        </div>
                        <div className="tool">
                          <div className="price">${item.price}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <FooterBar {...this.props} />
      </React.Fragment>
    );
  }
}

export default ProductDetail;
